import { Sport, SportOrShared } from '__generated__/globalTypes';
import { FootballLogo } from 'atoms/icons/FootballLogo';
import { MLBLogo } from 'atoms/icons/MLBLogo';
import { NBALogo } from 'atoms/icons/NBALogo';
import { useIntlContext } from 'contexts/intl';

import { glossary } from './glossary';

const formattedSports: Record<Sport, string> = {
  [Sport.FOOTBALL]: 'Football',
  [Sport.NBA]: 'NBA',
  [Sport.BASEBALL]: 'MLB',
};

const sportToSportOrShared: Record<Sport, SportOrShared> = {
  [Sport.FOOTBALL]: SportOrShared.FOOTBALL,
  [Sport.NBA]: SportOrShared.NBA,
  [Sport.BASEBALL]: SportOrShared.BASEBALL,
};

const sportOrSharedToSport: Record<SportOrShared, Sport | null> = {
  [SportOrShared.FOOTBALL]: Sport.FOOTBALL,
  [SportOrShared.NBA]: Sport.NBA,
  [SportOrShared.BASEBALL]: Sport.BASEBALL,
  [SportOrShared.GLOBAL]: null,
};

export const getSportFromSportOrShared = (
  sportOrShared: SportOrShared | null | undefined
) => {
  if (!sportOrShared) return null;
  return sportOrSharedToSport[sportOrShared];
};

export const getSportOrSharedFromSport = (sport: Sport | null | undefined) => {
  if (!sport) return null;
  return sportToSportOrShared[sport];
};

export const getFormattedSport = (sport: Sport) => formattedSports[sport];

export const useFormattedSport = () => {
  const { formatMessage } = useIntlContext();
  return (sport: Sport | null | undefined) => {
    if (sport && sport in Sport) {
      return getFormattedSport(sport as unknown as Sport);
    }
    return formatMessage(glossary.global);
  };
};

export const sportIcons: Record<Sport, React.ComponentType> = {
  [Sport.FOOTBALL]: FootballLogo,
  [Sport.BASEBALL]: MLBLogo,
  [Sport.NBA]: NBALogo,
};
